import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './VideoCard.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function VideoCard({ video }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isPrivate = video.visibility === 'private';
  const isOwner = user && video.userId && String(user.id) === String(video.userId);

  const thumbnailSrc =
    video.thumbnail && !video.thumbnail.startsWith('http')
      ? `${API_URL}${video.thumbnail}`
      : video.thumbnail;

  const formatViews = (views) => {
    if (views >= 1000000) {
      return `${(views / 1000000).toFixed(1)}M`;
    } else if (views >= 1000) {
      return `${(views / 1000).toFixed(1)}K`;
    }
    return views;
  };

  const formatDate = (date) => {
    const now = new Date();
    const videoDate = new Date(date);
    const diffTime = Math.abs(now - videoDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
    return `${Math.floor(diffDays / 365)} years ago`;
  };

  const formatPrice = (price) => {
    const value = Number(price) || 0;
    if (value <= 0) return 'Free';
    return `$${value.toFixed(2)}`;
  };

  const handleClick = () => {
    if (!isPrivate || isOwner) {
      navigate(`/video/${video._id}`);
    }
  };

  return (
    <div
      className={`video-card${isPrivate ? ' video-card--private' : ''}`}
      onClick={handleClick}
      style={
        isPrivate && !isOwner
          ? { cursor: 'not-allowed', opacity: 0.85 }
          : { cursor: 'pointer' }
      }
    >
      <div className="video-thumbnail">
        <img src={thumbnailSrc} alt={video.title} />
        {isPrivate && (
          <div className="video-badge video-badge--private">
            <Lock size={16} />
            <span>
              Private - contact admin for details
            </span>
          </div>
        )}
      </div>
      <div className="video-info">
        <img src={video.channelAvatar} alt={video.channel} className="channel-avatar" />
        <div className="video-details">
          <h3 className="video-title">{video.title}</h3>
          <p className="video-channel">{video.channel}</p>
          <p className="video-meta">
            {formatViews(video.views)} views • {formatDate(video.uploadDate)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default VideoCard;
